import './pD365Clients/pD365Clients.sass';
import './bD365Menu/bD365Menu.sass';
import './pD365PgConfig/pD365PgConfig.sass';
import './pD365ProcessConfig/pD365ProcessConfig.sass';
import './pD365Interrupts/pD365Interrupts.sass';

import { pD365ClientsDirective } from './pD365Clients/pD365Clients.directive';
import { bD365MenuDirective } from './bD365Menu/bD365Menu.directive';
import { pD365PgConfigDirective } from './pD365PgConfig/pD365PgConfig.directive';
import { pD365ProcessConfigDirective } from './pD365ProcessConfig/pD365ProcessConfig.directive';
import { pD365InterruptsDirective } from './pD365Interrupts/pD365Interrupts.directive';

import { D365Service } from './D365.service';

export default angular.module('frontend.d365', ["frontend.api", "frontend.auth", "frontend.theme"])
  .directive('pD365Clients', pD365ClientsDirective)
  .directive('bD365Menu', bD365MenuDirective)
  .directive('pD365PgConfig', pD365PgConfigDirective)
  .directive('pD365ProcessConfig', pD365ProcessConfigDirective)
  .directive('pD365Interrupts', pD365InterruptsDirective)
  .service('D365', D365Service);